/**
 * 入口。今の言語を決めて辞書を入れてから、アプリ本体（start.tsx）を読み込む。
 * `TEXT` は import 時に辞書を取り込むファイルが多いので、この順番を入れ替えない（docs/I18N.md）
 */
import { applyHtmlLang, browserLanguages, readStoredLanguage } from './adapters/language';
import { browserStorage } from './adapters/storage';
import { setActiveDictionary } from './config/i18n/active';
import { DICTIONARY_LOADERS } from './config/i18n/loaders';
import { resolveLanguage } from './domain/language';

const language = resolveLanguage(readStoredLanguage(browserStorage()), browserLanguages());
applyHtmlLang(language);
void DICTIONARY_LOADERS[language]().then(async ({ DICTIONARY }) => {
  setActiveDictionary(language, DICTIONARY);
  await import('./start');
});
